import { render, staticRenderFns } from "./EN_Instructions.vue?vue&type=template&id=3d5c2a4c&scoped=true&"
import script from "./EN_Instructions.vue?vue&type=script&lang=js&"
export * from "./EN_Instructions.vue?vue&type=script&lang=js&"
import style0 from "./EN_Instructions.vue?vue&type=style&index=0&id=3d5c2a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c2a4c",
  null
  
)

export default component.exports